// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CompassOutlinedSvg from "@fishx/icons-svg/es/asn/CompassOutlined";
import FishxIcon from '../components/FishxIcon';

var CompassOutlined = function CompassOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CompassOutlinedSvg
  }));
};

CompassOutlined.displayName = 'CompassOutlined';
export default React.forwardRef(CompassOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CompassOutlined.js
// module id = 2298
// module chunks = 0